angular.module('impactx.company').controller('CompanyDataCtrl', [
    '$scope',
    'ToastService',
    'dataGen',
    'BackService',
    '$routeParams',
    'CompanyService',
    'ConfirmationService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    '$mdDialog',
    '$config',
    'TinyMceHelperService',
    CompanyData
]);

function CompanyData($scope, ToastService, dataGen, BackService, $routeParams, CompanyService, ConfirmationService,
                     TranslationService, ToolbarService, PartialDialogsService, $mdDialog, $config, TinyMceHelperService) {

    $scope.tinymceOptions = TinyMceHelperService.getConfigurationWithUpload($config.tinymceOptions);

    var self = this;
    var hostingWasSet = false;

    $scope.superCompanyInputDataArray = [{field: "excludedComId", value: $routeParams.id}];
    $scope.additionalDataForEntryPoint = {comId: $routeParams.id};

    dataGen.getData($scope, {id: $routeParams.id}, "/company/view").then(function (data) {
        hostingWasSet = data.data.companyAttribute.isHostingCompany && data.data.companyAttribute.isHostingCompany.value;
        defineButtons();
    });

    self.checkCommentRequired = function () {
        if (!impactX.isDefined($scope, "data.companyAttribute.externalCommentsEnabled.value")) {
            $scope.data.companyAttribute.externalCommentsRequired.value = false;
        }
    }

    this.savePageData = function (event) {
        if ($scope.data.companyCard.id > 0 && hostingWasSet && !($scope.data.companyAttribute.isHostingCompany && $scope.data.companyAttribute.isHostingCompany.value)) {
            ConfirmationService.showConfirmationDialog(self.saveFinal, event, $scope.trns.hostingRemovedWarning,
                TranslationService.get("ok"), TranslationService.get("abort"));
        }
        else if ($scope.data.companyCard.id > 0 && !hostingWasSet && ($scope.data.companyAttribute.isHostingCompany && $scope.data.companyAttribute.isHostingCompany.value)) {
            ConfirmationService.showConfirmationDialog(self.saveFinal, event, $scope.trns.hostingAddedWarning,
                TranslationService.get("ok"), TranslationService.get("abort"));
        }
        else {
            return self.saveFinal(event);
        }
    };

    this.saveFinal = function ($event) {
        var dataObj = {
            data: $scope.data
        };

        return dataGen.post({}, dataObj, "/company/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            if(data && data.data && data.data.id) {
                var comId = data.data.id;
                PartialDialogsService.addNew(PartialDialogsService.TYPE.COMPANY, Number($routeParams.id), comId);
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.COMPANY, comId, 'companydata');
            }
            else {
                BackService.back();
            }
        });
    };

    self.deleteCompany = function () {
        var data = $scope.data;
        if (data) {
            data.id = Number($routeParams.id);
        }

        CompanyService.deleteCompany(data, false, null, true, '/company/delete');
    };

    // use a BooleanProperty as parameter
    this.toggleReadOnly = function (readOnly) {
        readOnly.value = !readOnly.value;
    };

    self.getEnforcementAreaEntries = function () {
        var required = $scope.data.companyMaster.enforcementArea.showMust && $scope.data.companyAttribute.isBuyer.value;
        return $scope.data.companyMaster.enforcementArea.entries.filter(function (entry) {
            return entry.id > 0 || !required;
        });
    };

    self.getCompanySizeEntries = function () {
        return $scope.data.companyMaster.companySize.entries;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.connectSuppliers,
                action: self.openConnectionDialog,
                type: 'dialogaction',
                condition: canConnect
            },
            {
                label: $scope.trns.disconnectSuppliers,
                action: self.disconnectSuppliers,
                type: 'dialogaction',
                condition: canDisconnect
            },
            {
                label: $scope.trns.save,
                action: self.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteCompany,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return $scope.data.companyMaster.canDelete
    }

    function canConnect() {
        return $scope.data.companyMaster.canConnect
    }

    function canDisconnect() {
        return $scope.data.companyMaster.canDisconnect
    }

    $scope.userItemTemplate =
        "<div><span md-highlight-text=\"searchText\" md-highlight-flags=\"i\" class=\"autocomplete-classification-name\">{{entry.value}}</span>" +
        "<span class=\"font-size-13 ix-helper-text autocomplete-classification-number\" md-highlight-text=\"searchText\" md-highlight-flags=\"i\">{{entry.secondValue}}</span></div>";

    self.openConnectionDialog = function (event) {
        $mdDialog.show({
            controller: 'SupplierConnectionCtrl',
            controllerAs: 'supplierConnectionCtrl',
            locals: {
                companyId: $routeParams.id
            },
            templateUrl: 'modules/company/templates/supplierconnection.dialog.html',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: event
        }).then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $scope.data.companyMaster.canConnect = false;
            $scope.data.companyMaster.canDisconnect = true;
        });
    };

    self.disconnectSuppliers = function () {
        return dataGen.postAsForm({}, {comId: $routeParams.id}, "/company/supplierconnection/disconnect").then(function(data) {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $scope.data.companyMaster.canConnect = true;
            $scope.data.companyMaster.canDisconnect = false;
        });
    }

}
